export default {"src":"/_next/static/media/icon_thumbs.79590edc.svg","height":44,"width":44,"blurWidth":0,"blurHeight":0};